<template>
    <div class="main-wrap">
        <div class="lab-wrap">
            <div class="character"
                 :style="{
                    backgroundImage: `url(https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/${age}${gender}_stand.png)`
                 }"
            >
            </div>
            <img class="working" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/lab_working.png" />
            <img class="loading" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/lab_loading.png" />
            <img class="comment" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/lab_comment.png" />
        </div>
        <div class="moving">
            <div class="message">
                {{ message }}{{ symbol }}
            </div>
            <div class="character"
                 :style="{
                    backgroundImage: `url(https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/${age}${gender}_${moving ? 'run' : 'stand'}.png)`
                 }"
            >
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                mode: '',
                message: '타임머신 가동 중',
                symbol: '',
                si: null,
                age: 70,
                moving: false,
            }
        },
        computed: {
            gender() {
                return this.$userData.gender.toLowerCase()
            }
        },

        beforeMount() {
            const id = this.$cookie.get('id')
            const localUserData = localStorage.getItem(`userData${id}`)
            if (localUserData) {
                const userData = JSON.parse(localUserData)
                Object.keys(userData).forEach(key => {
                    this.$set(this.$userData, key, userData[key])
                })
            }
        },

        beforeDestroy() {
            if (this.si) clearInterval(this.si)
        },

        mounted() {
            this.$stopAll()
            this.$playAudio(24)
            $('.lab-wrap').fadeIn(1000)
            setTimeout(_ => {
                $('.lab-wrap').fadeOut(1000, _ => {
                    $('.moving').fadeIn(1000)
                    let cnt = 0
                    this.si = setInterval(_ => {
                        if (cnt > 3) cnt = 0

                        let symbol = ''
                        for (let i = 0; i < cnt; i++) {
                            symbol += '.'
                        }

                        this.symbol = symbol

                        cnt++
                    }, 1000)

                    setTimeout(this.start, 1000)
                })

                this.resetUserData()
            }, 5000)



        },

        methods: {
            start() {
                let si

                this.$stopAll()

                this.$playAudio(12)

                this.moving = true
                $('.moving .character').animate({
                    left: 750,
                }, 5000, 'linear', _ => {
                    clearInterval(si)
                    $('.moving .character') .css('background-image', `url(https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/${this.age}${this.gender}_stand.png)`)
                        .css('background-position-x', 0)

                    $('.moving').fadeOut(2000, _ => {
                        this.$router.replace('/game')
                    })

                })

                let frame = 0
                let frameCnt = 0
                si = setInterval(_ => {
                    frame++
                    frameCnt++
                    if (frame >= 6) {
                        frame = 0
                    }
                    if (frameCnt % 5 === 0) {
                        if (this.age > 20) {
                            this.age -= 10
                        }
                    }

                    $('.moving .character').css('background-position-x', -132 * frame)

                }, 170)
            },

            resetUserData() {
                this.$eventBus.$emit('SET_ROUND', 2)

                this.$userData.round = 2
                this.$userData.age = 20
                this.$userData.sequence = 0
                this.$userData.factor1 = 50
                this.$userData.factor2 = 50
                this.$userData.factor3 = 50
                this.$userData.factor4 = 50
                this.$userData.penalty = 0
                this.$userData.spouse = 0
                this.$userData.hasBaby = false
                this.$userData.question = {}
                this.$userData.answers = {}
                this.$userData.ended = false
                this.$userData.results = []
                this.$userData.badgeCondition.forEach(cond => {
                    cond.value = 1
                })
                Object.keys(this.$userData.badgeCount).forEach(key => {
                    this.$userData.badgeCount[key] = 0
                })
                Object.keys(this.$userData.badges).forEach(key => {
                    this.$userData.badges[key] = false
                })

                const id = this.$cookie.get('id')
                localStorage.setItem(`userData${id}`, JSON.stringify(this.$userData))
            }
        }

    }
</script>

<style lang="scss" scoped>

    .main-wrap {
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000;
    }
    .lab-wrap {
        width: 945px;
        height: 590px;
        overflow: hidden;
        position: relative;
        background-image: url(https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_lab.png);
        background-size: cover;
        display: none;

        .background {
            position: absolute;
        }


        .character {
            position: absolute;
            width: 132px;
            height: 132px;
            bottom: 105px;
            left: 278px;
            transform: rotateY(180deg);

            background-size: auto 100%;
            background-position-x: 0;
        }

        .working {
            position: absolute;
            top: 203px;
            left: 305px;
        }

        .loading {
            position: absolute;
            top: 256px;
            left: 296px;
            -webkit-animation: vibrate-1 0.3s linear infinite both;
            animation: vibrate-1 0.3s linear infinite both;
        }

        .comment {
            position: absolute;
            bottom: 42px;
            left: 134px;
        }
    }

    .moving{
        width: 945px;
        height: 590px;
        overflow: hidden;
        position: absolute;
        background-color: #19162a;
        background-image: url(https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/tutorial_lights.png);
        background-repeat: no-repeat;
        background-position: center center;
        display: none;

        .message {
            font-size: 30px;
            color: #ffffff;
            font-family: GmarketSans, sans-serif;
            position: absolute;
            left: 353px;
            top: 277px;
        }
    }
</style>

<style>

    /**
     * ----------------------------------------
     * animation vibrate-1
     * ----------------------------------------
     */
    @-webkit-keyframes vibrate-1 {
        0% {
            -webkit-transform: translate(0);
            transform: translate(0);
        }
        20% {
            -webkit-transform: translate(-2px, 2px);
            transform: translate(-2px, 2px);
        }
        40% {
            -webkit-transform: translate(-2px, -2px);
            transform: translate(-2px, -2px);
        }
        60% {
            -webkit-transform: translate(2px, 2px);
            transform: translate(2px, 2px);
        }
        80% {
            -webkit-transform: translate(2px, -2px);
            transform: translate(2px, -2px);
        }
        100% {
            -webkit-transform: translate(0);
            transform: translate(0);
        }
    }
    @keyframes vibrate-1 {
        0% {
            -webkit-transform: translate(0);
            transform: translate(0);
        }
        20% {
            -webkit-transform: translate(-2px, 2px);
            transform: translate(-2px, 2px);
        }
        40% {
            -webkit-transform: translate(-2px, -2px);
            transform: translate(-2px, -2px);
        }
        60% {
            -webkit-transform: translate(2px, 2px);
            transform: translate(2px, 2px);
        }
        80% {
            -webkit-transform: translate(2px, -2px);
            transform: translate(2px, -2px);
        }
        100% {
            -webkit-transform: translate(0);
            transform: translate(0);
        }
    }

</style>
